<template>
  <v-container class="cmp-distribution-shops-sidewindow dt-sidewindow">
    <div class="dt-tabs-container">
      <div class="dt-details2">
        <div class="dt-details--header">
          <div class="title" :title="selectedShopDetails.title">
            <span>
              {{ selectedShopDetails.title }} (
              {{ $t(selectedShopDetails.channel) }} )
            </span>
          </div>
        </div>
      </div>
      <glayout
        :tabs="shopSidewindowTabs"
        :loading="selectedShopDetails && selectedShopDetails.loading"
      >
        <gtab>
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    selectedShopDetails &&
                      selectedShopDetails.related_shop_groups &&
                      selectedShopDetails.related_shop_groups.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
                :title="$t('tab_title_shop_groups')"
              >
                <ShopGroups
                  :selectedShopDetails="selectedShopDetails"
                  @selected="onSelectedShopGroup"
                  @add_click="onShopGroupAddClick"
                  @deleted="onDeletedShopGroup"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedShopDetails &&
                      selectedShopDetails.related_translations &&
                      selectedShopDetails.related_translations.length,
                    offset: NTOffsets.WithHeader,
                    min: 1
                  })
                "
                :title="$t('translations_string')"
              >
                <ShopTranslations :selectedShopDetails="selectedShopDetails" />
              </gbox>
            </gcol>
          </grow>
        </gtab>
      </glayout>
    </div>

    <ModalContainer :modalKey="'addShopGroups'" :width="'small'">
      <AddShopGroups @cancelled="onDialogCancelled" @added="onAddedShopGroup" />
    </ModalContainer>
  </v-container>
</template>

<script>
import { DistributionStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { mapActionObject, mapGetterObject } from "../../../../store/global";

import { shopsDistributionGetters } from "../../store/shops/getters";
import { shopsDistributionActions } from "../../store/shops/actions";

import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";
import {
  distributionShopListLDTRoutes,
  distributionShop_groupListLDTRoutes
} from "../../router/routes";
import { checkTabListPermission } from "../../../../router/guard";
import {
  createModalMixin,
  openModalRoute
} from "../../../../dt-plugins/modal/modal.mixin";
import BoxWidget from "@plugins/box-widget/box-widget";
import ModalContainer from "@dtplugins/modal/modal-container";

import ShopGroups from "./shop-groups";
import AddShopGroups from "./add-shop-groups";
import ShopTranslations from "./shop-translations";

export const moduleRoute = "distribution";
export const submenuRoute = "shops";

export default {
  components: {
    BoxWidget,
    ModalContainer,
    // DBoxFiles,
    // MetaData,

    ShopGroups,
    AddShopGroups,
    ShopTranslations
  },
  mixins: [createDTGridHost(), createModalMixin("addShopGroups")],
  computed: {
    ...mapGetterObject(storeNS, shopsDistributionGetters),

    shopSidewindowTabs: function() {
      return checkTabListPermission(moduleRoute, submenuRoute, [
        {
          route: "overview",
          value: this.$t("overview")
        }
      ]);
    },

    // TABULATION REFACTORING

    shop_id: function() {
      return this.$route.params.shop_id;
    },

    selectedShopDetails: function() {
      const selectedShop = this.shopDetails?.[this.shop_id] || {};
      // this.shopDetails && this.shopDetails[this.shop_id] || {}; shopDetails

      const shop = selectedShop.shop || {};

      const single_translation = selectedShop.single_translation || {};
      // selectedTrack.loading
      console.log("selected Shop", selectedShop);
      console.log("Shop Details Overview", shop);

      console.log("single_translation ", single_translation);

      const title = single_translation?.text01 || shop?.shop || "Shop Name";
      const channel =
        {
          physical_shop: "physical",
          digital_shop: "digital"
        }[(single_translation?.physical_shop)] ||
        shop?.channel ||
        "physical";

      return {
        ...selectedShop,
        title,
        channel,
        shop,
        single_translation
      };
    }
  },
  methods: {
    ...mapActionObject(storeNS, shopsDistributionActions),

    onDialogCancelled: function() {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined
        }
      });
    },

    onSelectedShopGroup: function(SelectedShopGroupId) {
      console.log("SelectedShopGroupId ", SelectedShopGroupId);

      this.$router.push({
        name: distributionShop_groupListLDTRoutes.names.tab,
        params: {
          shop_group_id: SelectedShopGroupId,
          tab: "overview"
        }
      });
    },
    onShopGroupAddClick: function() {
      openModalRoute(this, "add_shop_groups", {
        mode: "add"
      });
    },
    onAddedShopGroup: function(payload) {
      console.log("payload-- added ", payload);

      this[ActionTypes.ShopGroups.SET.ALL]({
        ...payload,
        selectedShopDetails: this.selectedShopDetails
      });
      this.onDialogCancelled();
    },
    onDeletedShopGroup: function(item) {
      this[ActionTypes.ShopGroups.DELETE.SINGLE]({
        // <-- Dispatch Method
        ...item,
        shop_id: this.shop_id
      });
    }
    // MARK: Methods
  }
};
</script>

<style lang="scss">
.cmp-distribution-shops-sidewindow {
  .dt-grid-layout {
    height: calc(100vh - 119px);
  }
}
</style>
